import { render } from "./AppealCreateView.vue?vue&type=template&id=1bf56a66"
import script from "./AppealCreateView.vue?vue&type=script&lang=js"
export * from "./AppealCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__